import {
    Box,
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
    Stack,
    Text,
    HStack,
    PinInput,
    PinInputField,
    // Collapse
} from "@chakra-ui/react";
import React from "react";
import Colors from "../../../assets/colors/Colors";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userLogin } from "../../../actions/user_actions";
import { GrubFormButton, GrubTitleText, GrubProgress, GrubNotification, GrubErrorMessage } from "../../../components/index";
import { WithRouter } from "../../../navigators/WithRouter";
import BackIconButton from "../components/BackIconButton";
import { usePhoneVerification } from "../hooks/usePhoneVerification";
const environment = process.env.REACT_APP_ENV || 'dev';
// import SignUp from "./SignUp";

const PhoneVerification = (props) => {
    const {
        otp,
        timer,
        isSubmitting,
        loading,
        isSignUpOpen,
        showLoginButton,
        showOtp,
        isOpenMessage,
        notificationMessage,
        errorMessage,
        formatTime,
        handleOtpChange,
        handleResendOTP,
        handleVerifyOTP,
        handleBackButton,
        handleSignInOpen,
        handleBackButtonSignUp,
    } 
    = usePhoneVerification(props);

    // = usePhoneVerification({
    //     ...props,
    //     onSignUp: (phoneNumber) => {
    //         // Close current verification modal
    //         props.onBack();
    //         // Open SignUp modal with pre-filled phone
    //         props.openSignUpModal && props.openSignUpModal({
    //             phone: phoneNumber,
    //             isOpen: true
    //         });
    //     },
    //     onVerifySuccess: (data) => {
    //         // Handle successful login case
    //         props.onVerifySuccess && props.onVerifySuccess(data);
    //     }
    // });

    return (
        <>
        <Modal
            isOpen={props.isOpen}
            size="sm"
            isCentered
            closeOnEsc={false}
            closeOnOverlayClick={false}
        >
            <ModalOverlay />
            <ModalContent 
                marginLeft="0.5rem" 
                marginRight="0.5rem"
                borderRadius="0.63rem"
            >
                {loading && (
                    <GrubProgress />
                )}
                <ModalBody 
                    pl={{ base: "2.56rem", md: "2.56rem" }}
                    pr={{ base: "2.56rem", md: "2.56rem" }}
                    pb={{ base: "4.13rem", md: "4.13rem" }}
                    pt={{ base: "1.88rem", md: "1.88rem" }}
                >
                    <BackIconButton
                        iconButton={true}
                        onClick={handleBackButton}
                    />
                    
                    {/* <Stack spacing={1} mb={8}>
                        <Text
                            fontSize="1.25rem"
                            fontWeight="600"
                            color="#1A1552"
                        >
                            Hi, Verify it's you
                        </Text>
                        <Text
                            fontSize="0.75rem"
                            color="#666"
                        >
                            Enter the six-digit code sent to XXXXXX-{props.phoneNumber.slice(-4)}
                        </Text>
                    </Stack> */}
                    <GrubTitleText
                        isLabelText={true}
                        fontSize="1.125rem"
                        color={Colors.posTextInfo}
                        name={"Hi, Verify it's you"}
                    />
                    <GrubTitleText
                        isLabelText={true}
                        fontSize="0.75rem"
                        color="#01004866"
                        fontWeight="300"
                        name={"Enter the six-digit code sent to XXXXXX-" + props.phoneNumber.slice(-4)}
                    />
                    <GrubTitleText
                        isLabelText={true}
                        fontSize="0.75rem"
                        color="#01004866"
                        fontWeight="300"
                        name={environment == "dev" || environment == "local" || environment == "staging" ? "OTP: " + showOtp : ""}
                    />

                    {/* <GrubNotification
                        isOpen={isOpenMessage}
                        message={notificationMessage}
                        time={3000}
                    /> */}
                    <HStack spacing={2} justify="center" mt={4} mb={6}>
                        <PinInput
                            size="lg"
                            value={otp}
                            onChange={handleOtpChange}
                            otp
                            placeholder=""
                            isDisabled={loading}
                            mask
                        >
                            {[...Array(6)].map((_, i) => (
                                <PinInputField
                                    key={i}
                                    autoFocus={i === 0}
                                    borderRadius="0.375rem"
                                    borderColor="#E2E8F0"
                                    _focus={{
                                        borderColor: Colors.taxInfo,
                                        boxShadow: "0rem 0rem 0rem 0.188rem " + Colors.inputHover,
                                    }}
                                    fontSize="1.25rem"
                                    width={{base: "2.35rem", md: "2.75rem"}}
                                    height={{base: "2.35rem", md: "2.75rem"}}
                                />
                            ))}
                        </PinInput>
                    </HStack>
                    {errorMessage?.error && errorMessage?.message?.length > 0 && (
                        <Text color="red.500" fontSize="sm">{errorMessage?.message}</Text>
                    )}

                    <Text
                        fontSize="0.75rem"
                        color={timer > 0 ? "#1A155280" : "#1A1552"} // Dim color when timer running
                        textAlign="left"
                        textDecoration={timer > 0 ? "none" : "underline"}
                        cursor={timer > 0 ? "default" : "pointer"}
                        mb={6}
                        mt={3}
                        onClick={() => {
                            if (timer === 0) {
                                handleResendOTP();
                            }
                        }}
                    >
                        {timer > 0 ? `Resend New Code After ${formatTime(timer)}` : 'Resend New Code'}
                    </Text>

                    <Box mt={4} mb={4}>
                        {/* {errorMessage?.error && errorMessage?.message?.length > 0 && (
                            <GrubErrorMessage
                                errorMessage={errorMessage.message}
                                width={"auto"}
                            />
                        )} */}
                        {notificationMessage?.message?.length > 0 && (
                            <GrubErrorMessage
                                errorMessage={notificationMessage?.message}
                                isError={notificationMessage?.isError}
                                width={"auto"}
                            />
                        )}
                    </Box>
                    <Box>
                        <GrubFormButton
                            isDisabled={loading}
                            bg="#1A1552"
                            buttonsubmit={(props.purpose && !props.phoneUpdate) == "LOGIN" ? "Login" : props.phoneUpdate ? "Update" : "Continue"}
                            width={"full"}
                            height="2.75rem"
                            onClick={() => {
                                handleVerifyOTP(otp);
                            }}
                        />
                    </Box>
                    <Text
                        fontSize="0.75rem"
                        color="#01004866"
                        textAlign="left"
                        fontWeight="300"
                        mt={4}
                    >
                        By creating an account, you agree to our Terms and conditions
                        and privacy statement
                    </Text>
                </ModalBody>
            </ModalContent>
        </Modal>
        {/* {isSignUpOpen && (
            <SignUp
                isOpen={isSignUpOpen}
                phoneNumber={props.phoneNumber}
                handleBackButton={handleBackButtonSignUp}
                handleSignInOpen={handleSignInOpen}
            />
        )} */}
        </>
    );
};
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            userLogin,
        },
        dispatch
    );
}
function mapStateToProps(state) {
    return {
        user: state.user,
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(PhoneVerification));